import { motion } from "framer-motion";
import { TrendingUp, Star } from "lucide-react";

const cases = [
  {
    industry: "Culver City Med Spa",
    timeframe: "5 months",
    metric: "+428%",
    metricLabel: "organic leads",
    detail: "From page 4 to top-3 for 18 high-intent local keywords.",
    quote: "We had to hire two more estheticians. Wild.",
  },
  {
    industry: "West LA Law Firm",
    timeframe: "7 months",
    metric: "$184K",
    metricLabel: "new revenue",
    detail: "Ranked #1 for 'Culver City personal injury lawyer' and 22 sister terms.",
    quote: "Best marketing investment I've made in 14 years of practice.",
  },
  {
    industry: "Local HVAC Company",
    timeframe: "90 days",
    metric: "+312%",
    metricLabel: "service calls",
    detail: "Went from invisible to 9-pack dominant across 6 West Side ZIPs.",
    quote: "Phone hasn't stopped ringing since month two.",
  },
];

const ProofResults = () => {
  return (
    <section className="py-20 md:py-28 bg-emerald-prestige text-primary-foreground relative overflow-hidden">
      <div className="absolute inset-0 grid-emerald opacity-30" />
      <div className="page-container relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/15 border border-accent/30 text-accent text-xs font-semibold uppercase tracking-wider mb-5">
            <Star className="w-3.5 h-3.5 fill-accent" /> Verified client results
          </div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight">
            Quiet wins.{" "}
            <span className="gold-gradient-text">Loud numbers.</span>
          </h2>
          <p className="mt-5 text-lg md:text-xl text-primary-foreground/75 leading-relaxed">
            Our clients ask to stay anonymous — they don't want competitors copying the playbook.
            The results are 100% real, and the receipts are one email away.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {cases.map((c, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative rounded-2xl p-7 bg-card/5 backdrop-blur-sm border border-primary-foreground/10 hover:border-accent/40 hover:bg-card/10 transition-all group"
            >
              <div className="flex items-start justify-between mb-5">
                <div>
                  <div className="text-xs text-accent uppercase tracking-wider font-semibold">
                    {c.industry}
                  </div>
                  <div className="text-xs text-primary-foreground/50 mt-0.5">
                    {c.timeframe}
                  </div>
                </div>
                <TrendingUp className="w-5 h-5 text-accent" />
              </div>

              <div className="mb-4">
                <div className="font-heading text-5xl font-bold gold-gradient-text leading-none">
                  {c.metric}
                </div>
                <div className="text-sm text-primary-foreground/70 mt-1">{c.metricLabel}</div>
              </div>

              <p className="text-sm text-primary-foreground/80 mb-5 leading-relaxed">
                {c.detail}
              </p>

              <div className="pt-4 border-t border-primary-foreground/10">
                <div className="text-sm italic text-primary-foreground/90">
                  "{c.quote}"
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProofResults;
